export default [
  {
    path: "/share",
    name: "share",
    meta: { title: "分享" },
    component: () => import("@/layouts/PageLayouts.vue"),
    children: [
      {
        path: "/share-chat/:id",
        name: "share-chat-index",
        component: () => import("@/views/share-page/index.vue"),
        meta: { title: "会话分享" },
      },
    ],
  },
];
